import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M21 13.876A8 8 0 1 0 6.119 8.618 7 7 0 0 0 3 18.609V20a1 1 0 0 0 1 1h1.392a7.002 7.002 0 0 0 9.99-3.119A8 8 0 0 0 17.876 17H20a1 1 0 0 0 1-1zM14 15a5 5 0 0 1-8 4H5v-1a5 5 0 1 1 9-3",
      clipRule: "evenodd"
    }
  )
);
var SvgChatFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ChatFilled_default = SvgChatFilled;

export { ChatFilled_default as default };
